import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { Button, Alert, Table, Popconfirm, message, ConfigProvider } from 'antd';
import SettingLayout from '../setting-layout';

import ResizeTable from '../resize-table';

import { getDownloadJobListApi, cancelDownloadJobApi } from './api';

import style from './index.less';

const { Header, Content } = SettingLayout;

const queryParam = {
  page: 0,
  size: 20
};

const taskStatus = {
  pending: '已提交导出任务',
  started: '已提交导出任务',
  finished: '导出成功',
  failed: '导出失败',
  cancelled: '已取消',
  canceled: '已取消',
  expired: '已过期'
};

function toLocalTime(timeStr) {
  return moment(moment.utc(timeStr).toDate()).format('YYYY-MM-DD HH:mm:ss');
}

function ExportTaskTable(props) {
  const { exportType = 'conversation_v3' } = props;
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);

  const getDownloadJobList = useCallback(() => {
    setLoading(true);
    getDownloadJobListApi({ ...queryParam, ...{ export_type: exportType } })
      .then(resq => {
        const { data = {} } = resq;
        const jobs = data.jobs || [];
        setList(
          jobs.map(item => {
            return {
              ...item,
              // 写死
              name: '历史对话导出',
              createAt: item.time_range.start_at ? toLocalTime(item.time_range.start_at) : '-',
              endAt: item.time_range.end_at ? toLocalTime(item.time_range.end_at) : '-',
              taskCreate: toLocalTime(item.created_at)
            };
          })
        );

        setLoading(false);
        setTotal(data.total || 0);
      })
      .catch(() => {
        setLoading(false);
        setList([]);
        setTotal(0);
      });
  }, []);

  const cancelDownloadJob = useCallback(id => {
    setLoading(true);
    cancelDownloadJobApi(id)
      .then(() => {
        message.success('取消成功');
        getDownloadJobList();
      })
      .catch(() => {
        message.error('取消失败');
        setLoading(false);
      });
  }, []);

  const onPageChange = useCallback(page => {
    queryParam.page = page - 1;
    getDownloadJobList();
  }, []);

  const onShowSizeChange = useCallback((page, size) => {
    queryParam.size = size;
    queryParam.page = 0;
    getDownloadJobList();
  }, []);

  const renderStatus = useCallback(row => {
    const { status } = row;
    let statusClass = style.status_pending;
    if (status === 'finished') {
      statusClass = style.status_success;
    }
    if (status === 'failed') {
      statusClass = style.status_error;
    }
    if (status === 'canceled') {
      statusClass = style.status_warning;
    }
    if (status === 'expired') {
      statusClass = style.status_warning;
    }
    return (
      <div className={`${style.status} ${statusClass}`}>
        <div>{taskStatus[status]}</div>
      </div>
    );
  }, []);

  const renderActive = row => {
    const { status, filename, id } = row;
    if (status === 'finished') {
      return (
        <a href={filename} target="_blank">
          {'下载'}
        </a>
      );
    }

    if (['pending', 'started'].includes(status)) {
      return (
        <Popconfirm
          title={'确认取消导出任务?'}
          onConfirm={() => cancelDownloadJob(id)}
          okText={'确认'}
          cancelText={'取消'}>
          <a href="javascript:;">{'取消'}</a>
        </Popconfirm>
      );
    }

    return <div> - </div>;
  };

  useEffect(() => {
    getDownloadJobList();
  }, []);

  return (
    <SettingLayout style={{ height: '100%' }}>
      <Header back>{'历史导出数据'}</Header>
      <Content maxWidth="100%">
        <div className={style.title}>
          <Button onClick={getDownloadJobList}>{'刷新数据'}</Button>
          <div className={style.alert_content}>
            <Alert
              className={style.alert}
              message={'任务列表并非实时更新，请点击刷新按钮刷新数据。导出文件有效期为3天，超过3天将无法下载，需重建导出任务。'}
              type="info"
              showIcon
            />
          </div>
        </div>
        <ResizeTable
          dataSource={list}
          loading={loading}
          pagination={{
            total,
            onChange: onPageChange,
            onShowSizeChange,
            current: queryParam.page + 1,
            pageSize: queryParam.size,
            pageSizeOptions: ['20', '30', '40', '50'],
            showSizeChanger: true,
            showQuickJumper: true
          }}>
          <Table.Column title={'数据开始时间'} dataIndex="createAt" />
          <Table.Column title={'数据结束时间'} dataIndex="endAt" />
          <Table.Column title={'任务创建时间'} dataIndex="taskCreate" />
          <Table.Column title={'状态'} render={renderStatus} />
          <Table.Column width={150} title={'操作'} render={renderActive} />
        </ResizeTable>
      </Content>
    </SettingLayout>
  );
}

ExportTaskTable.propTypes = {};

export default ExportTaskTable;
